export const ID = '7b28fc51-55b7-4ce2-b4c2-f4b3fa0f6695';

export const NAME = 'Standard Unit Listing';
